module.exports = __webpack_public_path__ + "img/up12.cd823d08.png";